import { useWindowSize } from '@uidotdev/usehooks';

export function useIsTablet() {
  const screenSize = useWindowSize();
  return screenSize.width && screenSize.width < 1300;
}
